import React from "react";
import "./messengerstyle.css"; // таны CSS энд байна

const MessengerChatButton = () => {
  const messengerLink = "https://m.me/204940676026469"; // таны Messenger page линк

  return (
    <ul className="smothscrolls">
      <li>
        <a
          href={messengerLink}
          target="_blank"
          rel="noopener noreferrer"
          title="Chat on Messenger"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 36"
            width="26"
            height="26"
            fill="currentColor"
          >
            <path d="M18 0C8.06 0 0 7.3 0 16.31c0 4.98 2.46 9.43 6.32 12.4v7.29l6.77-3.71c1.53.43 3.14.66 4.91.66 9.94 0 18-7.3 18-16.31C36 7.3 27.94 0 18 0zm1.73 21.79l-4.48-4.79-8.77 4.79 9.63-10.31 4.52 4.79 8.73-4.79-9.63 10.31z" />
          </svg>
        </a>
      </li>
    </ul>
  );
};

export default MessengerChatButton;
